// extracted by mini-css-extract-plugin
export default {"box":"GI7hX7InZHSAaaIFZtR1"};